export default function SuiviDroitBitumeConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('suivi.droit.bitume');
}

SuiviDroitBitumeConfiguration.$inject = ['$translatePartialLoaderProvider'];
